export const legalReviewKeys = ['controllerConfirmed', 'legalNoticeConfirmed', 'hostingTermsConfirmed', 'hostingTransfersConfirmed', 'supportHandlingConfirmed', 'supportTermsConfirmed'];
export function legalIssues(operator) {
  const issues = [];
  if (!operator.controller.name?.trim()) issues.push('controller.name');
  if (!operator.controller.addressLines?.length || operator.controller.addressLines.some(line => !line.trim())) issues.push('controller.addressLines');
  if (!operator.controller.country?.trim()) issues.push('controller.country');
  if (!operator.email?.includes('@')) issues.push('email');
  for (const locale of ['pt', 'en', 'de', 'es']) if (!operator.supportDetails[locale]?.trim()) issues.push(`supportDetails.${locale}`);
  for (const key of legalReviewKeys) if (operator.review[key] !== true) issues.push(`review.${key}`);
  return issues;
}

// Owner authorized publication with only the initiated Zoho DPA still pending.
// This release exception does not confirm that the agreement is executed.
export function publicationIssues(operator) {
  return legalIssues(operator).filter(issue => !(
    issue === 'review.supportTermsConfirmed' &&
    operator.publication?.pendingZohoDpaApprovedOn === '2026-10-14'
  ));
}
